export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 p-5 animate-pulse">
      <div class="h-4 bg-gray-700 rounded w-1/3 mb-3" />
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} class={`h-3 bg-gray-700 rounded mb-2 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonKPI() {
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 p-5 animate-pulse">
      <div class="h-3 bg-gray-700 rounded w-24 mb-3" />
      <div class="h-8 bg-gray-700 rounded w-16 mb-2" />
      <div class="h-3 bg-gray-700 rounded w-20" />
    </div>
  );
}

export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden animate-pulse">
      <div class="h-10 bg-gray-700/50" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} class="h-12 border-t border-gray-700/50 px-4 flex items-center">
          <div class="h-3 bg-gray-700 rounded w-full" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonChart({ height = 200 }: { height?: number }) {
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 p-5 animate-pulse">
      <div class="h-4 bg-gray-700 rounded w-32 mb-4" />
      <div style={{ height }} class="bg-gray-700/30 rounded" />
    </div>
  );
}
